import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/about-ripple.png'
import _imports_1 from './images/weight.png'


const _withScopeId = n => (_pushScopeId("data-v-b95d036c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img class=\"img-ripple\" src=\"" + _imports_0 + "\" data-v-b95d036c><img class=\"img-ripple-2\" src=\"" + _imports_0 + "\" data-v-b95d036c><h3 class=\"title\" data-v-b95d036c> 우리가 함께한 오늘의 실천 </h3><h6 class=\"subtitle\" data-v-b95d036c> 우리가 가져온 플라스틱,<br class=\"d-block d-md-none\" data-v-b95d036c> 지금까지 얼마나 모였을까요? </h6>", 4)
const _hoisted_7 = { class: "box-weight" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = { class: "weight" }
const _hoisted_10 = { class: "num" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("kg ")
const _hoisted_12 = { class: "desc" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "깨끗하고 아름다운 우리 바다를 위해", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("지금까지 ")
const _hoisted_15 = { class: "num" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("명")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("이 함께 해주셨어요.")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-none d-md-block" }, " 우리가 함께 깨끗하고 아름다운 우리 바다를 지켰어요. ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "d-block d-md-none" }, " 우리가 함께 깨끗하고 아름다운 바다를 지켰어요. ", -1))
const _hoisted_20 = { class: "section-footer" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("참여 인원: 이달의 바다 활동, 온라인 재활용 프로그램, "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode("가플지우 온라인아카데미 참여자 수 합계 기준")
], -1))

import { IEmartProgram } from '../../type';

  export interface IProps {
    program: IEmartProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

  ;

  

return (_ctx: any,_cache: any) => {
  const _component_AppNumberFormat = _resolveComponent("AppNumberFormat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(__props.program.custom_key?.configs?.collection_weight?.value), 1),
          _hoisted_11
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("p", null, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_component_AppNumberFormat, {
              value: __props.program.custom_key?.configs?.participation_member_count?.value,
              format: "0,0"
            }, null, 8, ["value"]),
            _hoisted_16
          ]),
          _hoisted_17
        ]),
        _hoisted_18,
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", null, "수거량: 이마트 " + _toDisplayString(__props.program.custom_key?.configs.tab2_section_1_store_count?.value) + "개 점포 수거 및 이달의 바다 활동 수거량 합계 기준", 1),
        _hoisted_21,
        _createElementVNode("div", null, "(" + _toDisplayString(__props.program.custom_key?.configs.tab2_section_1_update_date_2?.value) + " 기준 업데이트)", 1)
      ])
    ])
  ]))
}
}

})